import React, { Component, PropTypes } from 'react';
import Drawer from 'Cio/Drawer';
import ScrollableContainer from 'Cio/ScrollableContainer';
import * as SvgIcons from 'components/Material/SvgIcons';
import PageModuleMenuIcon from './ModuleMenu/PageModuleMenuIcon';
import { Units } from 'Css';
import {
  Toolbar,
  ToolbarGroup,
  ToolbarButton,
  ToolbarTitle
} from 'Cio/Toolbar';
import cx from 'classnames'

const css = oxygenCss({
  root: {
    overflow: 'hidden'
  },
  hide: {
    display: 'none'
  },
  row: {
    position: 'relative',
    display: 'flex'
  },
  container: {
    padding: `${Units.keyline}px 0`
  },
  column: {
    position: 'relative',
    textAlign: 'center',
    boxSizing: 'border-box',
    margin: Units.base / 2,
    flex: 1,
    height: Units.keyline * 2.5
  }
});

class PageModuleMenu extends Component {
  static propTypes = {
    closeModuleMenu: PropTypes.func,
    addPageModule: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  render() {
    const { closeModuleMenu, addPageModule, ...other } = this.props;

    const { getIntlMessage } = this.context;

    let isQuiz = false;
    this.props.course.toc.forEach(section => {
      if(section.type === 'quiz') {
        const ids = section.pages.map(p => p.id)
        if(ids.includes(this.props.course.lastViewedPageId)){
          isQuiz = true
        }
      }
    });

    return (
      <Drawer
        slide={false}
        className={css.root}
        onRequestClose={closeModuleMenu}
        {...other}
      >
        <ScrollableContainer
          padded
          header={
            <Toolbar>
              <ToolbarGroup>
                <ToolbarButton
                  onTouchTap={closeModuleMenu}
                  tooltip={getIntlMessage('Close')}
                >
                  <SvgIcons.ContentClear />
                </ToolbarButton>
              </ToolbarGroup>
              <ToolbarTitle>{getIntlMessage('page.addContent')}</ToolbarTitle>
            </Toolbar>
          }
        >
          <div className={cx(css.container, {[css.hide]: !isQuiz})}>
            <div className={css.row}>
              <PageModuleMenuIcon type={'task'} addPageModule={addPageModule} />
            </div>
          </div>
          <div className={cx(css.container, {[css.hide]: isQuiz})}>
            <div className={css.row}>
              <PageModuleMenuIcon type={'text'} addPageModule={addPageModule} />
              <PageModuleMenuIcon
                type={'image'}
                addPageModule={addPageModule}
              />
            </div>
            <div className={css.row}>
              <PageModuleMenuIcon
                type={'audio'}
                addPageModule={addPageModule}
              />
              <PageModuleMenuIcon
                type={'video'}
                addPageModule={addPageModule}
              />
            </div>
            <div className={css.row}>
              <PageModuleMenuIcon type={'task'} addPageModule={addPageModule} />
              <PageModuleMenuIcon
                type={'download'}
                addPageModule={addPageModule}
              />
            </div>
            <div className={css.row}>
              <PageModuleMenuIcon
                type={'discussion'}
                addPageModule={addPageModule}
              />
              <PageModuleMenuIcon
                type={'slideshow'}
                addPageModule={addPageModule}
              />
            </div>
            <div className={css.row}>
              <PageModuleMenuIcon
                type={'embed'}
                addPageModule={addPageModule}
              />
              <PageModuleMenuIcon
                type={'webinar'}
                addPageModule={addPageModule}
              />
            </div>
            <div className={css.row}>
              <PageModuleMenuIcon type={'quiziframe'} addPageModule={addPageModule} />
              <div className={css.column} />
            </div>
          </div>
        </ScrollableContainer>
      </Drawer>
    );
  }
}

export default PageModuleMenu;



// WEBPACK FOOTER //
// ./src/js/components/Page/PageModuleMenu.js